__turbopack_context__.v({
  "container": "styles-module-scss-module__1pwZxq__container",
  "video": "styles-module-scss-module__1pwZxq__video",
});
